import React from "react";
import { stddatetime, displayTransferRecipient } from "../utils/utils";

const TransferDetails = (transfer) => {
  const isPushToAccount = transfer.recipient?.type === "pushtoaccount";
  const isRequestForPay = transfer.originated_as_rfp === true;
  // `outgoing` is the viewer-side direction. For RfP:
  //   - outgoing=true → this user is the REQUESTER (money flows toward them)
  //   - outgoing=false → this user is the REQUESTEE (they're being asked to pay)
  const isRequester = isRequestForPay && transfer.outgoing === true;
  const isRequestee = isRequestForPay && transfer.outgoing === false;
  // Green "+" only when the requester has actually received the funds.
  const isIncomingCredit = isRequester && transfer.status === "SUCCEEDED";

  return (
    <div>
      <h3 style={{ margin: "-15px 0 -20px 0" }}>
        {isRequestForPay ? "Request details" : "Transfer details"}
      </h3>
      <div className="transfer_detail">Amount</div>
      <div
        style={{
          fontSize: "17px",
          fontWeight: 600,
          color: isIncomingCredit ? "#13a61f" : undefined,
        }}
        data-cy="transfer_details_amount"
      >
        {isRequester ? "+" : ""}${parseFloat(transfer.amount?.value).toFixed(2)}
      </div>
      <div className="transfer_detail">
        {isRequester
          ? "Requested From"
          : isRequestee
            ? "Requested By"
            : "Recipient"}
      </div>
      <div
        style={{ overflowWrap: "break-word" }}
        data-cy="transfer_details_recipient"
      >
        {isRequestee
          ? transfer.sender_identifier ||
            transfer.sender_name ||
            "A user on this platform"
          : displayTransferRecipient(transfer.recipient, false, transfer)}
      </div>
      {isPushToAccount && transfer.from_account_type && (
        <>
          <div className="transfer_detail">From Account</div>
          <div>{transfer.from_account_type} {transfer.from_account_number}</div>
        </>
      )}
      {isPushToAccount && transfer.to_routing_number && (
        <>
          <div className="transfer_detail">To Routing Number</div>
          <div>{transfer.to_routing_number}</div>
          <div className="transfer_detail">To Account Number</div>
          <div>{transfer.to_account_number}</div>
        </>
      )}
      <div className="transfer_detail">Date</div>
      <div data-cy="transfer_details_date">
        {stddatetime(new Date(transfer.timestamp + "Z"))}
      </div>
      <div className="transfer_detail">Comment</div>
      <div data-cy="transfer_details_note">{transfer.note}</div>
      <div className="transfer_detail">Reference ID</div>
      <div>{transfer.id}</div>
    </div>
  );
};

export default TransferDetails;
